import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiateSessionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { InitiateSessionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const initiateSession = (request: InitiateSessionRequest, options?: CashRequestOptions) =>
  post<InitiateSessionRequest, InitiateSessionResponse>('/2.0/cash/initiate-session', request, {
    ...options,
    rejectOnError: true,
  })
